'use client';

import { useEffect } from 'react';
import { trackEventDetailView } from '@/lib/analytics';

interface EventDetailAnalyticsProps {
  eventSlug: string;
  eventId?: string;
}

/**
 * Tracks event detail view for conversion funnel (Landing → Search → Event Detail → External Link).
 */
export function EventDetailAnalytics({ eventSlug, eventId }: EventDetailAnalyticsProps): null {
  useEffect(() => {
    trackEventDetailView(eventId ?? eventSlug, eventSlug);
  }, [eventSlug, eventId]);

  return null;
}
